export const workflowStyles = (factoryTheme) => ({
    boxHeader: {
        paddingBottom: factoryTheme.spacing(2),
    },
    boxContent: {
        paddingTop: factoryTheme.spacing(2),
    },
});
